import { InjectionToken } from '@angular/core';
import type { AbstractFileService } from './abstract-file.service';

export const FILE_SERVICE_TOKEN = new InjectionToken<AbstractFileService>('FILE_SERVICE_TOKEN');
